module.exports = __webpack_public_path__ + "static/media/opkomst-verdeling.d89aee59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Seats/assets/opkomst-verdeling.svg
// module id = 479
// module chunks = 0